import React from 'react';
import {useContext, useContextSelector} from 'use-context-selector';
import MessageClientStatus from './MessageClientStatus';
import {Button} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes'

import {LocalContext} from '../context/LocalContext';

const FeedClientStatus = () => {
    const [localData, setLocalData] = useContext(LocalContext);
    const { t } = useTranslation();

    const clientStatusMessages = useContextSelector(LocalContext, v => v[0].clientStatusMessages);

    const handleMessagesDestroy = () => {
        setLocalData({...localData, clientStatusMessages: []});
    }

    return <>{clientStatusMessages.length > 0 ?
        <div
            style={
                {
                    background: 'var(--gray)',
                    maxHeight: '100vh',
                    overflow: 'auto',
                    display: 'flex',
                    flexShrink: 0,
                    flexGrow: 1,
                    flexDirection: 'column'
                }
            }
            className="client-status-message border-bottom border-secondary"
        >
            <style>
                {
                    `
                        .client-status-message .alert {
                            border-radius: 0;
                            margin: 0;
                        }
                    `
                }
            </style>
            <div
                style={
                    {
                        display: 'flex',
                        overflow: 'auto',
                        flexDirection: 'column',
                        maxHeight: '100%'
                    }
                }>
                <div
                    style={
                        {
                            display: 'flex',
                            flexDirection: 'column-reverse',
                        }
                    }
                >
                    {clientStatusMessages.map((messageData) => <MessageClientStatus key={messageData.uuid} messageData={{...messageData}} />)}
                </div>
            </div>

            {clientStatusMessages.length >= 2 ?
                <Button
                    className="ml-auto mt-1"
                    variant="outline-light"
                    size="sm"
                    onClick={handleMessagesDestroy}
                >
                    <FontAwesomeIcon icon={faTimes} />
                    {' '}
                    {t('FeedClientStatus.close-these-messages-Plural')}
                </Button> :
                null}
        </div> : null}</>
}

export default FeedClientStatus;
